import { useCallback, useRef } from "react";
import { useTranslation } from "react-i18next";

import { useGimbalControl } from "providers/GimbalControlProvider";

import FunctionalButton from "components/layout/FunctionalButton";
import { ReactComponent as MinusIcon } from "assets/svgs/Minus.svg";
import { ReactComponent as PlusIcon } from "assets/svgs/Plus.svg";

/** @param {{ direction: 1 | -1, className?: string }} props */
const ZoomGimbalButton = ({ direction, className = "" }) => {
    const { t } = useTranslation("control");
    const { sendGimbalZoom } = useGimbalControl();
    const activeRef = useRef(false);

    const stopZoom = useCallback(() => {
        if (!activeRef.current) return;
        activeRef.current = false;
        sendGimbalZoom(0);
    }, [sendGimbalZoom]);

    const startZoom = useCallback(
        (event) => {
            event.preventDefault();
            if (activeRef.current) return;
            activeRef.current = true;
            try {
                event.currentTarget.setPointerCapture?.(event.pointerId);
            } catch {
                /* ignore capture failures */
            }
            sendGimbalZoom(direction);
        },
        [direction, sendGimbalZoom],
    );

    const title = direction === 1 ? t("buttons.zoomIn") : t("buttons.zoomOut");
    const Icon = direction === 1 ? PlusIcon : MinusIcon;

    return (
        <FunctionalButton
            className={`control-button-type3 select-none touch-none ${className}`}
            aria-label={title}
            icon={<Icon className="h-4 w-4" />}
            onPointerDown={startZoom}
            onPointerUp={stopZoom}
            onPointerCancel={stopZoom}
            onLostPointerCapture={stopZoom}
            onContextMenu={(event) => event.preventDefault()}
        />
    );
};

export const ZoomInGimbalButton = ({ className = "" }) => (
    <ZoomGimbalButton direction={1} className={className} />
);

export const ZoomOutGimbalButton = ({ className = "" }) => (
    <ZoomGimbalButton direction={-1} className={className} />
);

export default ZoomGimbalButton;
